<template>
    <div id="app" class="light" v-bind:class="{'dark':isDark}">
        <div class="row-min-auto bPrimary">
            <Sidebar />
            <div class="col-auto">
                <Header />
                <div class="main-container">
                    <router-view />
                </div>
            </div>
        </div>
        <Error />
    </div>
</template>

<script>
import Sidebar from "./components/layouts/Sidebar";
import Header from "./components/layouts/Header";
import Error from "./components/layouts/Error";
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "app",
    created() {
        this.fetchTheme();
    },
    components: {
        Sidebar,
        Header,
        Error
    },
    methods: {
        ...mapMutations(["fetchTheme"])
    },
    computed: {
        ...mapGetters(["isDark"])
    }
};
</script>

<style lang='scss'>
/** Imports */

#app {
    .row-min-auto {
        display: grid;
        grid-template-columns: min-content auto;
        .col-auto {
            padding: 0;
            .main-container {
                height: calc(100vh - 4.5rem);
                position: relative;
                overflow: auto;
            }
        }
    }
    // Default styles
    height: 100vh;
    width: 100vw;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
}

@import "./assets/scss/themes";
@import "./assets/scss/defaults";
</style>
